<template>
  <div>
    <b-card no-body class="card-transparent-background">
      <b-card-header class="p-0">
        <b-card-title class="card-title-form-steps-garden-help">
          Subscription registration
        </b-card-title>
        <b-card-sub-title class="card-subtitle-form-steps-garden-help">
          Please provide us with your details to start working now
        </b-card-sub-title>
      </b-card-header>
      <b-card-body class="p-0">
        <b-card no-body class="py-2 px-3">
          <b-card-title class="card-title-garden-help">
            Card Details
          </b-card-title>
          <b-card-body class="py-2 px-1">
            <div class="container p-0">
              <StripeForm
                client_name="GARDENHELP"
                form_group_class="form-group-garden-help"
                label_class="form-label-garden-help"
                input_class="form-control-garden-help"
                button_text="Subscribe"
                button_variant="garden-help-secondary"
                button_class="btn-garden-help w-100"
              />
            </div>
          </b-card-body>
        </b-card>
      </b-card-body>
    </b-card>
  </div>
</template>
        
<script>
import StripeForm from "@/components/Payment/StripeForm.vue";

export default {
  name: "FilesInputView",
  components: { StripeForm },
  props: [],

  data() {
    return {};
  },
  mounted() {},

  computed: {},
  methods: {},
};
</script>



// WEBPACK FOOTER //
// src/projects/garden_help/contractor/profile_details_components/PaymentView.vue